import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../configs/authConfig";
import { Button } from "@mui/material";
// import { Button } from "@mui/material";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
  const { instance } = useMsal();
  console.log(instance);
  const handleLogin = (loginType) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e) => {
        console.log("popup");
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.log(e);
      });
    }
  };
  return (
    <Button
      variant="contained"
      onClick={(e) => {
        e.preventDefault();
        handleLogin("popup");
      }}
    >
      Sign In
    </Button>
  );
};
